import { render, staticRenderFns } from "./ImportAddress.vue?vue&type=template&id=3255a82b&scoped=true&"
import script from "./ImportAddress.vue?vue&type=script&lang=js&"
export * from "./ImportAddress.vue?vue&type=script&lang=js&"
import style0 from "./ImportAddress.vue?vue&type=style&index=0&id=3255a82b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3255a82b",
  null
  
)

export default component.exports